import script from "./WorkshopLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkshopLayout.vue?vue&type=script&setup=true&lang=js"

import "./WorkshopLayout.vue?vue&type=style&index=0&id=311f749a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311f749a"]])

export default __exports__